import { render, staticRenderFns } from "./NutritionVitalityCard.vue?vue&type=template&id=111a9c1c&scoped=true"
import script from "./NutritionVitalityCard.vue?vue&type=script&lang=js"
export * from "./NutritionVitalityCard.vue?vue&type=script&lang=js"
import style0 from "./NutritionVitalityCard.vue?vue&type=style&index=0&id=111a9c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111a9c1c",
  null
  
)

export default component.exports